namespace Solovis.Site.DragDropManager {
    

    /**
     * Turns element into a drag drop source for a Solovis type. Format should be:
     * { type: "entity"/"investment"/etc., value: {} }, or a function that returns the same.
     */
    export function setupSolovisRefDrag(element, solovisRef) {        
        if (element instanceof jQuery) {
            element = (element as JQuery).get(0);
        }
        
        if (solovisRef) {
            element.setAttribute("draggable", true);            

            var node = element;

            node.ondragstart = function (e) {
                var solovisRefToUse;
                if (typeof solovisRef == "function") {
                    solovisRefToUse = solovisRef();
                }
                else {
                    solovisRefToUse = solovisRef;
                }

                var solovisRefText = "solovis-ref|" + JSON.stringify(solovisRefToUse);

                e.dataTransfer.setData("text", solovisRefText);
            };

            node.addEventListener('selectstart', function (e) {
                // Make drag start work in IE.
                e.preventDefault();
                this.dragDrop();
                return false;
            }, false);
        }
    }


    export function setupSolovisRefDrop(element, callback) {
        var jElement = $(element);
        var node = jElement.get(0);

        node.addEventListener("dragenter", function (e) {
            // Allow drop.
            e.preventDefault();
        });

        node.addEventListener("dragover", function (e) {
            // Allow drop.
            e.preventDefault();
        });

        node.addEventListener("drop", function (e) {     
            e.preventDefault();

            var data = e.dataTransfer.getData("text");
            if (data && data.indexOf("solovis-ref|") == 0) {
                try {
                    var solovisRefJson = data.substr("solovis-ref|".length);
                    var solovisRef = JSON.parse(solovisRefJson);
                    callback(solovisRef);
                }
                catch (ex) {
                    console.log("ERROR: processing solovis-ref drop event");
                    console.log(ex);
                }
            }

            return false;
        });
    }


    /**
     * Turns element into a drag drop source for a Solovis report with state.
     * @param element
     * @param reportControl
     * @param elementName
     */
    export function setupSolovisReportControlDrag(element, reportControl, elementName?) {        
        var jElement = $(element);
        if (reportControl) {
            (jElement as any).attr("draggable", true);

            var node = jElement.get(0);            

            node.ondragstart = function (e) {
                var reportControlToUse;
                if (typeof reportControl == "function") {
                    reportControlToUse = reportControl();
                }
                else {
                    reportControlToUse = reportControl;
                }

                if (reportControlToUse) {                    
                    var reportRef = reportControlToUse.createReportReference(elementName); 
                    var reportRefText = "solovis-report|" + JSON.stringify(reportRef);

                    e.dataTransfer.setData("text", reportRefText);
                }
            };

            node.addEventListener('selectstart', function (e) {
                // Make drag start work in IE.
                e.preventDefault();
                (this as any).dragDrop();
                return false;
            }, false);
        }
    }


    export function setupSolovisReportDrop(element, callback) {
        var jElement = $(element);
        var node = jElement.get(0);

        node.addEventListener("dragenter", function (e) {
            // Allow drop.
            e.preventDefault();
        });

        node.addEventListener("dragover", function (e) {
            // Allow drop.
            e.preventDefault();
        });

        node.addEventListener("drop", function (e) {
            e.preventDefault();

            var data = e.dataTransfer.getData("text");
            if (data && data.indexOf("solovis-report|") == 0) {                
                try {
                    var reportRefJson = data.substr("solovis-report|".length);
                    var reportRef = JSON.parse(reportRefJson);
                    callback(reportRef);
                }
                catch (ex) {
                    console.log("ERROR: processing solovis-report drop event");
                    console.log(ex);
                }                
            }

            return false;
        });
    }

}


if (typeof window != "undefined") {
    // NOTE: We have to handle drop events on the window (or Firefox will try to navigate to the text url).
    window.addEventListener("drop", function (e) {
        e.preventDefault();
        return false;
    });

    window.addEventListener("dragover", function (e) {
        e.preventDefault();
        return false;
    });

    window.addEventListener("dragenter", function (e) {
        e.preventDefault();
        return false;
    });
}